import { SCORING } from '../lib/scoring.js'

/**
 * Quick scoring cheat sheet for the dashboard sidebar. Pulls directly from
 * SCORING so it can never drift from the engine.
 *
 * Order matches the tiers people care about most: do this thing → get points.
 */
export default function HowToEarn() {
  const rules = [
    {
      label: SCORING.ORIGINAL_POST.label,
      points: `+${SCORING.ORIGINAL_POST.points}`,
      detail: 'Per post that passes the content gate.',
    },
    {
      label: SCORING.COMMENT.label,
      points: `+${SCORING.COMMENT.points}`,
      detail: `Up to ${SCORING.COMMENT.cap.limit} a week.`,
    },
    {
      label: SCORING.REPOST.label,
      points: `+${SCORING.REPOST.points}`,
      detail: `Up to ${SCORING.REPOST.cap.limit} a week.`,
    },
    {
      label: SCORING.IMPRESSIONS_1K.label,
      points: `+${SCORING.IMPRESSIONS_1K.points}`,
      detail: 'Awarded per post that crosses 1,000 impressions.',
    },
    {
      label: SCORING.IMPRESSIONS_5K.label,
      points: `+${SCORING.IMPRESSIONS_5K.points}`,
      detail: 'Awarded per post that crosses 5,000 impressions. Replaces the 1k bonus.',
    },
    {
      label: SCORING.IMPRESSIONS_20K.label,
      points: `+${SCORING.IMPRESSIONS_20K.points}`,
      detail: 'Awarded per post that crosses 20,000 impressions. Replaces the 5k bonus.',
    },
    {
      label: SCORING.QUALIFIED_INBOUND.label,
      points: `+${SCORING.QUALIFIED_INBOUND.points}`,
      detail: 'Verified DM or call traced to one of your posts.',
    },
  ]

  return (
    <div className="bg-white border border-brand-border rounded-xl p-5 shadow-card">
      <h4 className="text-xs uppercase tracking-wider font-semibold text-brand-text-muted mb-3">
        How to earn points
      </h4>
      <ul className="space-y-2.5">
        {rules.map(r => (
          <li key={r.label} className="flex items-start gap-3">
            <span className="text-sm font-bold text-brand-blue w-12 shrink-0 tabular-nums">
              {r.points}
            </span>
            <div className="min-w-0 flex-1">
              <div className="text-sm text-brand-text font-medium leading-tight">{r.label}</div>
              <div className="text-xs text-brand-text-muted leading-snug mt-0.5">{r.detail}</div>
            </div>
          </li>
        ))}
      </ul>
      <p className="text-[11px] text-brand-text-muted mt-4 pt-3 border-t border-brand-border italic">
        Posts must be Climatise-relevant. The content gate filters spam.
      </p>
    </div>
  )
}
